import MUIDataTable from "mui-datatables";
import { useEffect, useState } from "react";

import CustomSelectToolbar from "./CustomSelectToolbar";

import { useTranslation } from "react-i18next";
import { getColumns, getOptions } from "./config";

const List = ({ data }) => {
	const { t } = useTranslation();
	const [tableData, setTableData] = useState(data);
	const [selectedRows, setSelectedRows] = useState([]);

	useEffect(() => {
		setTableData(data);
	}, [data]);

	const handleRemove = (rowIndex) => {
		setSelectedRows([]);
		setTableData((prevData) => {
			return prevData.filter((row, index) => index !== rowIndex);
		});
	};

	const handleUpdate = (rowIndex, column, value) => {
		setTableData((prevData) =>
			prevData.map((row, index) => {
				return index === rowIndex ? { ...row, [column]: value } : row;
			})
		);
	};

	const handleCheckboxChange = (rowIndex, groupId, checked) => {
		setTableData((prevData) =>
			prevData.map((row, index) => {
				return index === rowIndex
					? {
							...row,
							mailingGroups: {
								...row.mailingGroups,
								[groupId]: { ...row.mailingGroups[groupId], checked },
							},
					  }
					: row;
			})
		);
	};

	const columns = getColumns(
		handleRemove,
		handleUpdate,
		handleCheckboxChange,
		t
	);
	const options = getOptions(t);

	return (
		<MUIDataTable
			className="mui-data-table import-table center-all-cells"
			data={tableData}
			columns={columns}
			options={{
				...options,
				onRowsDelete: (rowsDeleted) => {
					const dataDeleted = rowsDeleted.data.map((d) => d.index);
					setTableData((prevData) =>
						prevData.filter((_, i) => !dataDeleted.includes(i))
					);
					setSelectedRows(
						selectedRows.filter((rowIndex) => !dataDeleted.includes(rowIndex))
					);

					return false;
				},
				onRowSelectionChange: (currentRowsSelected, allRowsSelected) => {
					setSelectedRows(allRowsSelected.map((row) => row.index));
				},
				rowsSelected: selectedRows,
			}}
			components={{ TableToolbarSelect: CustomSelectToolbar }}
		/>
	);
};

export default List;
